import {IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";

export class LqbPricerLogParametersService {

    public static instance = ['$http', LqbPricerLogParametersService];

    public $http: IHttpService;

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    getLqbPricerParametersNames = () => this.$http({url: getAbsoluteUrl("api/pricer/parameters"), method: 'GET'});

}